module.exports = __webpack_public_path__ + "img/error_forbidden.70b02bdd.svg";